export default __webpack_public_path__ + "static/media/milestones.9f93274f.svg";